module.exports = __webpack_public_path__ + "img/one_platform2.a92a1302.png";